import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { EmployeeBulkStatusUpdateRequest } from "../request/EmployeeBulkStatusUpdateRequest";
import { EmployeeBulkStatusUpdateApiResponse } from "../model/EmployeeBulkStatusUpdateApiResponse";

const EmployeeBulkStatusApiService = async (
  request: EmployeeBulkStatusUpdateRequest
): Promise<EmployeeBulkStatusUpdateApiResponse> => {
  const url = "/employees/bulk_status_update/";
  const { data } = await axios.post(url, request);
  return data;
};

// TODO : Add return type
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeBulkStatusApiService = () =>
  useMutation<
    EmployeeBulkStatusUpdateApiResponse,
    AxiosError,
    EmployeeBulkStatusUpdateRequest
  >(EmployeeBulkStatusApiService, {
    mutationKey: ["EmployeeBulkStatusApiService"],
  });

export default useEmployeeBulkStatusApiService;
